import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { newSupplierCreation } from "./supplierAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaArrowLeft } from 'react-icons/fa';
import { getAllSupplier } from "./supplierAction";

import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Swal from "sweetalert2";
import { Link ,useNavigate} from 'react-router-dom';

const CreateSupplier = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const SupplierRef = useRef(null);
  const [suppliername,setSuppliername]= useState('');
  const [mobile,setMobile]= useState('');
  const [email,setEmail]= useState('');
  const [password,setPassword]= useState('');
  const [addressone,setAddressone]= useState('');
  const [addresstwo,setAddresstwo]= useState('');
  const [contactperson,setContactperson]= useState('');
  const [status,setStatus]= useState('');
  const [mobileError, setMobileError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [nameError ,setNameError] = useState(false);
  const [contactPError ,setContactPError] = useState(false);

  
  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, formState: { errors } } = useForm();

  
const [passwordError, setPasswordError] = useState('');
  
 
  const { supiscLoading, supcstatus, supcMessage, } = useSelector((state) => state.supplierList);

  useEffect(() => {
    dispatch(getAllSupplier());
  }, [dispatch,supcMessage]); 

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if(suppliername && mobile && email && password && addressone && addresstwo && contactperson && status){
        const newSupplierCreation1 = {
            suppliername,
            mobile,
            email,
            password,
            addressone,
            addresstwo,
            contactperson,
            status
        };
        dispatch(
            newSupplierCreation(newSupplierCreation1)
        )
        Swal.fire('Supplier Created Successfully!', '', 'success')

        setSuppliername('')
        setMobile('');
        setEmail('');
        setPassword('');
        setAddressone('');
        setAddresstwo('');
        setContactperson('');
        setStatus('');

        navigate('/supplierLists');
        e.target.reset();
    }
 
  };

  const canSave = Boolean (suppliername) && Boolean(mobile) && Boolean(email) && Boolean(addressone)  && Boolean(addresstwo)  && Boolean(contactperson) && Boolean(status) && password.length >= 8 &&  !mobileError && !emailError && !nameError && !contactPError;
//console.log(curstatus);
//console.log('msg');
//console.log(curmessage);
  //console.log(passwordError.confirmPassword);
  
  return (
    <>
     
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create New Supplier</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                          <Col>
                            <Link to="/supplierLists"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
                            </Col>
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridSupplierName">
                  <Form.Label>Supplier Name</Form.Label>
                  <Form.Control type="text" ref={SupplierRef} maxLength={50}  name="suppliername" required="true" autoComplete='off' placeholder="Enter Supplier Name" {...register("suppliername", { required: true, mixLength: 3 })} 
                   onChange={(e) => {
                    const value = e.target.value;
                    setSuppliername(value)
                    if (!/^[a-zA-Z]+$/.test(value)) {
                      setNameError('Enter valid supplier name');
                    } else {
                      setNameError('');
                    }
                  }}
                    />
                  {errors.suppliername && <p className='text-danger'> Supplier Name required</p>}
                  {nameError && <p className='text-danger'> Enater valid name</p>}
                </Form.Group>
               
                <Form.Group as={Col} controlId="formGridMobile">
                  <Form.Label>Mobile No</Form.Label>
                  <Form.Control
  type="text"
  ref={SupplierRef}
  name="mobile"
  required={true}
  autoComplete="off"
  placeholder="Enter Mobile No"
  {...register("mobile", { required: true })}
  onChange={(e) => {
    const value = e.target.value;
    setMobile(value);
  
    if (!/^\d+$/.test(value) || (value.length < 10 || value.length >= 15)) {
      setMobileError('Enter a valid mobile number');
    } else {
      setMobileError('');
    }
  }}
  
/>
{errors.mobile && <p className="text-danger">Mobile No required</p>}
{mobileError && <p className="text-danger">{mobileError}</p>}

                </Form.Group>
                </Row>

                <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridEmail">
                  <Form.Label>Email Id</Form.Label>
                  {/* <Form.Control type="text" ref={SupplierRef}  name="email" required="true" autoComplete='off' placeholder="Enter Email" {...register("email", { required: true, mixLength: 3 })}  onChange={(e) => setEmail(e.target.value)}/>
                  {errors.email && <p className='text-danger'> Email Id required</p>} */}
                  <Form.Control
  type="text"
  ref={SupplierRef}
  name="email"
  required={true}
  maxLength={40}
  autoComplete="off"
  placeholder="Enter Email"
  {...register("email", { required: true, mixLength: 3 })}
  onChange={(e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value.includes('@')) {
      setEmailError('Email should contain @');
    } else {
      setEmailError('');
    }
  }}
/>
{errors.email && <p className="text-danger">Email Id required</p>}
{emailError && <p className="text-danger">Enter valid enail address</p>}

                </Form.Group>
               
                {/* <Form.Group as={Col} controlId="formGridPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" ref={SupplierRef}  name="password" required="true" autoComplete='off' placeholder="Enter Pasword" {...register("password", { required: true, mixLength: 3 })}  onChange={(e) => setPassword(e.target.value)}/>
                  {errors.password && <p className='text-danger'> Password required</p>}
                </Form.Group> */}
                <Form.Group as={Col} controlId="formGridPassword">
  <Form.Label>Password</Form.Label>
  <Form.Control
    type="password"
    ref={SupplierRef}
    name="password"
    required="true"
    autoComplete="off"
    placeholder="Enter Password"
    {...register("password", { required: true, minLength: 8 })}  // Set minimum length to 8
    onChange={(e) => {
      setPassword(e.target.value);
      if (e.target.value.length < 8) {
        setPasswordError('Password should be at least 8 characters long.');
      } else {
        setPasswordError('');
      }
    }}
  />
  {errors.password && <p className="text-danger">Password required</p>}
  {passwordError && <p className="text-danger">{passwordError}</p>}  
</Form.Group>

                </Row>

                <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridAddress1">
                  <Form.Label>Address 1</Form.Label>
                  <Form.Control type="text" ref={SupplierRef} maxLength={100}  name="addressone" required="true" autoComplete='off' placeholder="Enter Address1" {...register("addressone", { required: true, mixLength: 3 })}  onChange={(e) => setAddressone(e.target.value)}/>
                  {errors.addressone && <p className='text-danger'> Address1 required</p>}
                </Form.Group>
               
                <Form.Group as={Col} controlId="formGridAddress2">
                  <Form.Label>Address 2</Form.Label>
                  <Form.Control type="text" ref={SupplierRef} maxLength={100}  name="addresstwo" required="true" autoComplete='off' placeholder="Enter Address2" {...register("addresstwo", { required: true, mixLength: 3 })}  onChange={(e) => setAddresstwo(e.target.value)}/>
                  {errors.addresstwo && <p className='text-danger'> Address2 required</p>}
                </Form.Group>
                </Row>
                <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridContactPerson">
                  <Form.Label>Contact Person</Form.Label>
                  <Form.Control type="text" ref={SupplierRef} maxLength={50} name="contactperson" required="true" autoComplete='off' placeholder="Enter Contact Person" {...register("contactperson", { required: true, mixLength: 3 })} 
                   onChange={(e) => {
                    const value = e.target.value;
                    setContactperson(value)
                    if (!/^[a-zA-Z]+$/.test(value)) {
                      setContactPError('Enter valid supplier name');
                    } else {
                      setContactPError('');
                    }
                  }}
                    />
                  {errors.contactperson && <p className='text-danger'> Contact Person required</p>}
                  {contactPError && <p className='text-danger'> Enter valid name</p> }
                </Form.Group>
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" value={status} onChange={(e) => setStatus(e.target.value)}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle' disabled={!canSave}>
              <FontAwesomeIcon icon={faRightToBracket} /> Submit
              </Button>
              </div>
              {supiscLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
            </div>
            </div>
            </div>
    </>
  );
}

export default CreateSupplier;